import { ETab } from '../types/tab';
import { ESortType } from '../types/sort';

export const TABS = [
  { value: ETab.Reviews, title: 'Отзывы' },
  { value: ETab.Questions, title: 'Вопросы' },
];

export const QUESTION_TAB_EXCLUDED_SORT = [ESortType.By_rating_asc, ESortType.By_rating_desc];
